import * as Yup from 'yup'

import { PROFILE_ROUTE_NAMES } from '../../constants/route'
import { MOBILE_SCREEN_MAX_WIDTH } from '../../constants/screen'
import { isApiSuccessStatus } from '../../utils/api'
import { formValidationSchemaNoChanged } from '../Form'
import { SCREEN_WIDTH_HIDE_TABLE_CONTROL_BAR_TEXT } from '../Table'

import {
  DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH,
  DOC_FLOW_SCREEN_WIDTH_HIDE_TABLE_CONTROL_BAR_TEXT,
} from './DocFlow.constants'

function isEqualEditFinalDocTitle({ initialValues, name, values }) {
  return initialValues[name] === values[name]
}

export function getDocFlowCreationSuccessNotification({ data, t }) {
  return {
    linkProps: {
      title: t('Notification.DocumentStaplingCreatedViewDocumentLinkKey'),
      to: PROFILE_ROUTE_NAMES.docFlow(data.id),
    },
    text: t('Notification.DocumentStaplingCreatedTextKey', {
      name: data.name,
    }),
    title: t('Notification.DocumentStaplingCreatedTitleKey'),
    withCloseButton: true,
  }
}

export function getValidationSchemaEditFinalDocTitle({
  fieldName,
  initialValues,
  t,
}) {
  return Yup.object({
    [fieldName]: Yup.string()
      .required(true)
      .max(
        DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH,
        t('Error.MaxLengthKey', {
          length: DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH,
        })
      ),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: isEqualEditFinalDocTitle,
      isEqualProps: { name: fieldName },
    })
  )
}

export function getMassActionsSuccessItemsLength(data) {
  if (data?.ready) {
    return data.result?.ids.length
  }

  return data?.filter(i => isApiSuccessStatus(i.status_code)).length
}

export function getDocFlowIsHiddenTableControlBarText({ screenWidth }) {
  const isDocFlowCompactLayout =
    screenWidth > MOBILE_SCREEN_MAX_WIDTH &&
    screenWidth <= DOC_FLOW_SCREEN_WIDTH_HIDE_TABLE_CONTROL_BAR_TEXT

  const isMobileTableLayout =
    screenWidth <= SCREEN_WIDTH_HIDE_TABLE_CONTROL_BAR_TEXT

  return isDocFlowCompactLayout || isMobileTableLayout
}
